var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
const SvgOutstandingCreditNotes = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.5 12.5C12.2239 12.5 12 12.2761 12 12C12 11.7239 12.2239 11.5 12.5 11.5H20.5C20.7761 11.5 21 11.7239 21 12C21 12.2761 20.7761 12.5 20.5 12.5H12.5Z",
    fill: "#111111"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.5 8.5C12.2239 8.5 12 8.27614 12 8C12 7.72386 12.2239 7.5 12.5 7.5H20.5C20.7761 7.5 21 7.72386 21 8C21 8.27614 20.7761 8.5 20.5 8.5H12.5Z",
    fill: "#111111"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15 23.5C14.8469 23.5 14.7099 23.4312 14.6182 23.3228C14.1045 24.2384 13.1245 24.8571 12 24.8571H6.5C4.84314 24.8571 3.5 23.514 3.5 21.8571V18C3.5 16.3431 4.84315 15 6.5 15H8V5C8 4.33696 8.26339 3.70107 8.73223 3.23223C9.20107 2.76339 9.83696 2.5 10.5 2.5H22.5C23.163 2.5 23.7989 2.76339 24.2678 3.23223C24.7366 3.70107 25 4.33696 25 5V17C25 17.1326 24.9473 17.2598 24.8536 17.3536L18.8536 23.3536C18.7598 23.4473 18.6326 23.5 18.5 23.5H15ZM4.5 20.5V21.8571C4.5 22.9617 5.39543 23.8571 6.5 23.8571H12C13.1046 23.8571 14 22.9617 14 21.8571V20.5H4.5ZM15 21.8571C15 22.0795 14.9758 22.2963 14.9299 22.5049C14.9528 22.5017 14.9762 22.5 15 22.5H18V17C18 16.7239 18.2239 16.5 18.5 16.5H24V5C24 4.60217 23.842 4.22065 23.5607 3.93934C23.2794 3.65804 22.8978 3.5 22.5 3.5H10.5C10.1022 3.5 9.72064 3.65804 9.43934 3.93934C9.15804 4.22064 9 4.60217 9 5V15H12C13.6569 15 15 16.3431 15 18V21.8571ZM14 19.5H4.5V18.5H14V19.5ZM19 17.5H23.2929L19 21.7929V17.5ZM4.56301 17.5H13.937C13.715 16.6374 12.9319 16 12 16H6.5C5.56808 16 4.78503 16.6374 4.56301 17.5Z",
    fill: "#111111"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgOutstandingCreditNotes, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/outstanding-credit-notes.cacc5db7.svg";
export { ForwardRef as ReactComponent };